// extracted by mini-css-extract-plugin
module.exports = {"module":"input_module__2bPVt","label":"input_label__2tmVe","input":"input_input__Q80XR"};